import React from 'react'

const SvgOfferExpand = ({ title, ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>{title}</title>
    <defs>
      <path
        d="M11.3328,7.19319 C10.92809,6.81035 10.26918,6.81294 9.87112,7.18948 L6,10.851351 L2.128884,7.18948 C1.726332,6.80869 1.075293,6.80716 0.667198,7.19319 L0.732802,7.13113 C0.328087,7.51397 0.322586,8.12947 0.72374,8.50894 L5.27626,12.815381 C5.67597,13.193486 6.32259,13.194851 6.72374,12.815381 L11.27626,8.50894 C11.67597,8.13084 11.67529,7.51717 11.2672,7.13113 L11.3328,7.19319 Z"
        id="path-1"
      />
      <path
        d="M11.3328,1.19319 C10.92809,0.81035 10.26918,0.81294 9.87112,1.18948 L6,4.85135 L2.128884,1.18948 C1.726332,0.80869 1.075293,0.80716 0.667198,1.19319 L0.732802,1.13113 C0.328087,1.51397 0.322586,2.12947 0.72374,2.50894 L5.27626,6.81538 C5.67597,7.19349 6.32259,7.19485 6.72374,6.81538 L11.27626,2.50894 C11.67597,2.13084 11.67529,1.51717 11.2672,1.13113 L11.3328,1.19319 Z"
        id="path-3"
      />
    </defs>
    <g id="final" fill="none" fillRule="evenodd">
      <g id="expand">
        <g id="Group">
          <rect id="Rectangle-20" width="16" height="16" />
          <g id="expand-copy" transform="translate(2 1)">
            <mask id="mask-2" fill="#fff">
              <use xlinkHref="#path-1" />
            </mask>
            <use id="Clip-2" fill="#EA6100" xlinkHref="#path-1" />
            <mask id="mask-4" fill="#fff">
              <use xlinkHref="#path-3" />
            </mask>
            <use id="Clip-5" fill="#EA6100" xlinkHref="#path-3" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default SvgOfferExpand
